<template>
    <v-container>

        <!-- HEADER -->
        <v-row class="mt-5" align="center">
            <v-col cols="12">
                <div class="title-section">
                    Carpetas
                </div>
            </v-col>
            <v-col cols="4">
                <v-icon color="black" large>mdi-folder-multiple-outline</v-icon>
                <b>Carpetas creados</b>
            </v-col>
            <v-col cols="4">
                <v-btn v-if="isAdmin || isAmbUser" class="normal-btn" color="primary" depressed @click="showCreateDialog">
                    <v-icon left>mdi-plus-circle-outline</v-icon>
                    Crear Carpeta
                </v-btn>
            </v-col>
            <v-col cols="4">
                <kimsa-text-field
                    placeholder="Buscar"
                    append-icon="mdi-magnify"
                    outlined dense solo flat
                    @change="search = $event"
                />
            </v-col>
        </v-row>

        <!-- TABLE -->
        <v-data-table
            class="mt-5"
            :headers="headers"
            :loading="loading"
            :items="folders"
            :search.sync="search"
        >
            <template v-slot:item.actions="{ item }">
                <v-btn class="mr-1 my-1" fab outlined x-small @click.stop="editItem(item)">
                    <v-icon>mdi-pencil</v-icon>
                </v-btn>
                <v-btn v-if="isAdmin" class="mr-1 my-1" fab outlined x-small @click.stop="deleteItem(item)">
                    <v-icon color="primary">mdi-delete</v-icon>
                </v-btn>
            </template>
        </v-data-table>

        <!-- COMPONENTS -->
        <create-folder-dialog @success="loadFolders" ref="creator" />

        <kimsa-confirm
            title="Eliminar"
            content="¿Esta seguro que desea eliminar esta Carpeta?"
            persistent
            @confirm="onConfirmDelete"
            @cancel="currentId = null"
            :loading="loadingDelete"
            no-close-on-confirm
            ref="confirm"
        />

    </v-container>
</template>

<script>
import Axios from "@/utils/Axios";
import KimsaConfirm from "@/components/common/KimsaConfirm";
import KimsaTextField from "@/components/common/inputs/KimsaTextField";
import CreateFolderDialog from "@/components/document/CreateFolderDialog";

export default {
    name: "Folders",
    components: {CreateFolderDialog, KimsaTextField, KimsaConfirm},
    data() {
        return {
            loading: false,
            folders: [],
            search: '',
            currentId: null,
            loadingDelete: false,
            headers: [
                {text: 'Client', value: 'client', class: 'grey white--text'},
                {text: 'Nombre', value: 'name', class: 'grey white--text'},
                {text: 'Actualización', value: 'updated_at', class: 'grey white--text'},
                {text: '', value: 'actions', sortable: false, class: 'grey'},
            ],
        }
    },
    async mounted() {
        const vm = this
        await vm.loadFolders()
    },
    methods: {
        async loadFolders() {
            const vm = this
            vm.loading = true

            await Axios.post('folders').then(res => {
                // console.log('res loadFolders',res)
                vm.folders = res.data.result.folders.map(folder => {
                    return {
                        id: folder.id,
                        name: folder.name,
                        client: folder.client?.name || 'n/d',
                        created_at: vm.$moment(folder.created_at).format('DD-MM-YYYY'),
                        updated_at: vm.$moment(folder.updated_at).format('DD-MM-YYYY'),
                    }
                })
                console.log('vm.folders',vm.folders)
            }).catch(er => {
                console.log('error loadFolders', er)
            }).finally(() => {
                vm.loading = false
            })
        },
        showCreateDialog() {
            const vm = this
            vm.$refs.creator.show()
        },
        editItem(item) {
            const vm = this
            vm.$refs.creator.loadFolder(item.id)
        },
        deleteItem(item) {
            const vm = this
            vm.$refs.confirm.show()
            vm.currentId = item.id
        },
        async onConfirmDelete() {
            const vm = this
            vm.loadingDelete = true

            await Axios.delete(`folder/${vm.currentId}/delete`).then(res => {
                // console.log('res onConfirmDelete',res)
                vm.toast('Carpeta eliminada')
            }).catch(er => {
                console.log('er',er)
                vm.toast('error onConfirmDelete', er)
            })

            vm.loadingDelete = false
            vm.currentId = null

            vm.$refs.confirm.hide()
            await vm.loadFolders()
        },
    }
}
</script>

<style scoped>

.title-section {
    color: var(--v-primary-base);
}

</style>